import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './ubi-core/auth-guard.service';
import { UbiLoginComponent } from './theme/components';

const appRoutes: Routes = [
  { path: 'login', component: UbiLoginComponent },
  { path: '',   redirectTo: '/', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/app-routing.module.ts